var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-right" },
    [
      _c(
        "b-button",
        {
          staticClass: "btn-icon rounded-circle mt-1",
          attrs: { size: "sm", id: "popover-old", variant: "flat-primary" }
        },
        [_c("feather-icon", { attrs: { icon: "InfoIcon" } })],
        1
      ),
      _c(
        "b-popover",
        {
          attrs: { target: "popover-old", triggers: "focus", placement: "top" },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function() {
                return [_c("span", [_vm._v("Basarse en un flujo actual!")])]
              },
              proxy: true
            }
          ])
        },
        [
          _c("span", [
            _vm._v(
              " Otra opción sería basarte en una plantilla de aprobaciones existente, esto tendría ya configurado los pasos y las consecuencias de todo el proceso que estás a punto de iniciar. "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }